module.exports = __webpack_public_path__ + "img/calcasieu-lake-charles.9dc0d7f8.jpg";